<template>
  <v-layout column>
    <v-flex>
      <v-toolbar>
        <v-toolbar-title>Login</v-toolbar-title>
      </v-toolbar>
        <form name="filmklubb-form">
          <v-text-field
            label="E-post"
            v-model="email"
            ></v-text-field>
          <br>
          <v-text-field
            label="Lösenord"
            type="password"
            v-model="password"
            ></v-text-field>
          <br>
          <div class="error" v-html="error" />
          <v-btn @click="login">Login</v-btn>
        </form>
    </v-flex>
  </v-layout>
</template>

<script>
import AuthenticationService from '@/services/authentication_service'
export default {
  data () {
    return {
      email: '',
      password: '',
      error: null
    }
  },
  methods: {
    async login () {
      try {
        const response = await AuthenticationService.login({
          email: this.email,
          password: this.password
        })
        this.$store.dispatch('setToken', response.data.token)
        this.$store.dispatch('setUser', response.data.user)
        this.$router.push({
          name: 'movies'
        })
      } catch (error) {
        this.error = error.response.data.error
      }
    }
  }
}
</script>

<style scoped>
.error {
  color: red;
}
</style>



// WEBPACK FOOTER //
// src/components/Login.vue